/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import qs from 'query-string'

import Request from 'generic/request/Request'

export const ENTITY_LIST_URL = '/api/entity/list/'
export const APPLICANT_ENTITY_LIST_URL = '/api/applicant/entity/list/'
export const CONSUMER_ENTITY_LIST_URL = '/api/consumer/entity/list/'
const ENTITY_URL = '/api/entity/'
const ENTITY_VALIDATION_URL = '/api/entity/validation/'

export function getEntities(params) {
  const query = {
    ...params,
    meta: false,
    objects_count: false,
  }

  return Request.getRequest(ENTITY_LIST_URL + '?' + qs.stringify(query))
    .then((results) => {
      return results.data.objects.objects
    })
}

export const getEntity = (uid) => {
  return Request.getRequest(ENTITY_URL + (uid ? uid + '/' : ''))
    .then((result) => {
      return result.data.object
    })
}

export const postEntityValidation = (data, uid) => {
  return Request.postRequest(ENTITY_VALIDATION_URL + (uid ? uid + '/' : ''), data)
    .then((result) => {
      return result.data.object
    })
}



// WEBPACK FOOTER //
// ./src/actions/Entity.js